import { savePersist, getDataObject } from "./data";

export const saveUserData = (user, key, val) => {
  const userData = getDataObject("User.Persist");
  userData[key] = val;
  savePersist(user);
};
